import { FormBuilder, FormControl } from '@angular/forms';

import { AllocationViewFilterName, AllocationViewFiltersModel } from '../../allocation-view';

export class AllocationViewFilterProfileModel {
  id: number;
  name: string;
  filters: AllocationViewFiltersModel;

  constructor(params?: AllocationViewFilterProfileModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export interface AllocationViewFilterProfileDto {
  id?: number;
  profileId?: number;
  userId?: number;
  name?: string;
  defaultProfile?: boolean;
  filters?: AllocationViewFiltersModel;
  allocationViewFilter?: AllocationViewFiltersModel;
}

export interface AllocationViewFilterProfilesResponseDto {
  profiles: AllocationViewFilterProfileDto[];
}

export const mapAllocationViewFilterProfileResponse = (
  dto: AllocationViewFilterProfileDto,
): AllocationViewFilterProfileModel =>
  new AllocationViewFilterProfileModel({
    id: dto.id ?? dto.profileId,
    name: dto.name,
    filters: mapAllocationViewFiltersResponse(dto.filters ?? dto.allocationViewFilter),
  });

export const mapAllocationViewFilterProfileRequest = (
  item: AllocationViewFilterProfileModel,
): AllocationViewFilterProfileDto => ({
  id: item.id,
  name: item.name,
  filters: mapAllocationViewFiltersRequest(item.filters),
});

export const mapAllocationViewFiltersResponse = (filters: AllocationViewFiltersModel): AllocationViewFiltersModel => {
  if (!filters) {
    return filters;
  }

  const compartmentDockStructure =
    filters[AllocationViewFilterName.CompartmentDockStructure] ??
    filters['compartments' as keyof AllocationViewFiltersModel];
  const type = filters[AllocationViewFilterName.Type] ?? filters['types' as keyof AllocationViewFiltersModel];

  return new AllocationViewFiltersModel({
    ...filters,
    [AllocationViewFilterName.Type]: type,
    [AllocationViewFilterName.CompartmentDockStructure]: Array.isArray(compartmentDockStructure)
      ? { compartments: compartmentDockStructure }
      : compartmentDockStructure,
  } as AllocationViewFiltersModel);
};

export const mapAllocationViewFiltersRequest = (filters: AllocationViewFiltersModel): AllocationViewFiltersModel => {
  if (!filters) {
    return filters;
  }

  const {
    compartmentDockStructure,
    timeFrame: _timeFrame,
    type,
    ...requestFilters
  } = filters as AllocationViewFiltersModel & {
    compartmentDockStructure?: { compartments?: unknown[] } | unknown[];
    timeFrame?: unknown;
    type?: unknown[];
  };

  return {
    ...requestFilters,
    type: type ?? [],
    compartmentDockStructure: {
      compartments: Array.isArray(compartmentDockStructure)
        ? compartmentDockStructure
        : compartmentDockStructure?.compartments ?? [],
    },
  } as unknown as AllocationViewFiltersModel;
};

export class AllocationViewFilterProfileFormModel {
  constructor(
    model: AllocationViewFilterProfileModel,
    fb: FormBuilder = new FormBuilder(),
    public id: FormControl<number> = fb.control<number>(model.id),
    public name: FormControl<string> = fb.control<string>(model.name),
    public filters: FormControl<AllocationViewFiltersModel> = fb.control<AllocationViewFiltersModel>(model.filters, []),
  ) {}
}
